import type { PerAssessmentResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import _ from 'lodash'
import { useQuery } from 'react-query'

type FormOption = {
  label: string
  value: string
}

export const formUrl = '/api/list/forms'

const useFormOptions = () => {
  const formQuery = useQuery<PerAssessmentResponse>(
    formUrl,
    () => getJSON({ url: formUrl }),
    {}
  )

  const formOptions = _(formQuery?.data?.result)
    .map((form: { name: string; formId: string }) => ({
      label: form.name.replace('Mental Capacity Assessment', 'MCA'),
      value: form.formId
    }))
    .orderBy('label')
    .value() as unknown as FormOption[]
  return formOptions
}

export default useFormOptions
